import "./styled.css";
import ImageFace from "../../assets/images/image_1.webp";
import { getDic } from "../../assets/i18n/dictionary";

export default function StepIndex(props) {
  const {
    configOptions,
    lightenHex,
    step,
    setStep
  } = props;

  return (
    <>
      <div className="div-steps" style={{
        background: lightenHex(configOptions.buttonBackgroundColor, -20),
        border: `1px solid ${lightenHex(configOptions.buttonBackgroundColor, -40)}`,
        boxShadow: `0px 4px 12px ${lightenHex(configOptions.buttonBackgroundColor, -40)}`,
      }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <img src={ImageFace} className="img-faceHeader" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              color: configOptions.buttonTextColor
            }}
          >
            <h2>{getDic("foto-para-reconhecimento-facial")}</h2>
          </div>
        </div>

        <span style={{ color: configOptions.buttonTextColor }}>{getDic("passo")} {step} {getDic("de")} 3</span>

        <div className="div-stepDots">
          {[1, 2, 3].map((s, i) => (
            <div key={s} className="div-stepDots-row">
              {i > 0 && (
                <div
                  className={`step-line ${s <= step ? "step-line--active" : ""}`}
                  style={{
                    background: configOptions.buttonTextColor,
                    opacity: s <= step ? 1 : 0.5
                  }}
                />
              )}
              <div
                className={`step-dot ${s === step ? "step-dot--active" : ""} ${s < step ? "step-dot--done" : ""}`}
                style={{
                  background: configOptions.buttonTextColor,
                  opacity: s <= step ? 1 : 0.5
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
